import { organicSearchTypes } from "app/common/keyword-research/search-competitors/searchTypeConsts";

import { Connected } from "./KeywordCompetitors";

export const KeywordCompetitorsOrganicPage = () => {
    const tabMetaData = {
        tableApi: `/widgetApi/SearchCompetitorsOrganicTotal/SearchCompetitorsOrganic/Table`,
        excelApi: `/widgetApi/SearchCompetitorsOrganicTotal/SearchCompetitorsOrganic/Excel`,
        domainsCountApi: `/widgetApi/SearchCompetitorsOrganicTotal/SearchCompetitorsOrganic/DomainsCounts`,
        i18nPrefix: `analysis.competitors.search.organic.table`,
        metric: `KeywordCompetitorsOrganicTable`,
        tableSelectionTracking: `Keyword Competitors Organic`,
        tableSelectionKey: "KeywordCompetitorsOrganicTable",
        searchTypeFilterPlaceholder: "analysis.competitors.search.organic.table.filters.searchtype",
        searchTypeParam: "organicSearchType",
        searchTypes: organicSearchTypes,
        title: "analysis.competitors.search.organic.title",
    };
    return <Connected tabMetaData={tabMetaData} />;
};
